export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-948_tn.dcc8d51b.jpg";